import { render, staticRenderFns } from "./licenseList.vue?vue&type=template&id=5bbb03b3&scoped=true&"
import script from "./licenseList.vue?vue&type=script&lang=js&"
export * from "./licenseList.vue?vue&type=script&lang=js&"
import style0 from "./licenseList.vue?vue&type=style&index=0&id=5bbb03b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb03b3",
  null
  
)

export default component.exports